import React, { useState, useEffect } from 'react';
import FacturacionForm from '../../components/Facturacion/FacturacionForm';
import { getFactusUserData, createOrUpdateFactusUserData } from '../../services/facturationService';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';

const FacturacionPage = () => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const data = await getFactusUserData();
                setUserData(data);
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    setUserData(null);
                } else {
                    setError('Hubo un error al cargar tus datos de facturación.');
                    console.error(err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const handleSubmit = async (formData) => {
        setError(null);
        try {
            const updatedData = await createOrUpdateFactusUserData(formData);
            setUserData(updatedData);
            alert('¡Datos guardados exitosamente!');
        } catch (err) {
            if (err.response && err.response.data && err.response.data.detail) {
                setError(err.response.data.detail);
            } else {
                setError('Ocurrió un error inesperado. Inténtalo de nuevo.');
            }
            console.error(err);
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, borderRadius: '16px' }}>
            <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Datos de Facturación
            </Typography>
            
            {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}

            {userData ? (
                <>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        Tus datos fiscales ya están registrados. Puedes actualizarlos a continuación.
                    </Typography>
                    <FacturacionForm onSubmit={handleSubmit} initialData={userData} />
                </>
            ) : (
                <>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        Aún no has registrado tus datos fiscales. Por favor, completa el siguiente formulario para poder emitir tus facturas.
                    </Typography>
                    <FacturacionForm onSubmit={handleSubmit} />
                </>
            )}
        </Paper>
    );
};

export default FacturacionPage;